<!-- Top Nav -->
<nav *ngIf="(showSideNav=='top' || myUser.userType == 'professionalManager' || myUser.userType == 'professional' || myUser.userType == 'admin') || (showSideNav=='bottom')"
	class="navbar navbar-light"
	[ngClass]="{backgroundNavbar: loggedIn, hideSideNav:sideNavBarVisibilityService.hideSideNav==true, 'weightmans-theme-nav-bar': themeService.theme == 'weightmans', 'theme-nav-bar': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme', 'bluecoat-nav-bar': themeService.theme == 'bluecoat'}">
	<section class="closing-side-nav-btn" (click)="openSideNav()">
		<i class="fa fa-2x fas fa-bars"></i>
	</section>
	<section class="navbar-brand" [ngClass]="{'navbar-brand-bluecoat': themeService.theme == 'bluecoat'}">
		<section class="themes-section">
			<img *ngIf="loggedIn" src="../../assets/img/{{themeService.theme}}/main-logo.png" alt="Company Logo"
				width="125px" [ngClass]="{'img-theme-nav-bar': themeService.theme == 'life-file'}">
			<!-- <section class="themes-divs">
				<div class="theme-div default" (click)="defaultTheme()"></div>
				<div class="theme-div orange" (click)="lifeFileTheme()"></div>
				<div class="theme-div blue" (click)="pemTheme()"></div>
				<div class="theme-div purple" (click)="palmersTheme()"></div>
				<div class="theme-div pink" (click)="boosstTheme()"></div>
				<div class="theme-div green" (click)="weightmansTheme()"></div>
				<div class="theme-div black" (click)="NWRTheme()"></div>
				<div class="theme-div navy" (click)="bluecoatTheme()"></div>
			</section> -->
		</section>
	</section>
	<section class="navbar-brand-logo-sponsor"
		*ngIf="logoSponsor == true && mobileScreen && myUser.userType!='professionalManager' && themeService.theme != 'bluecoat'">
		<div class="logo-container">
			<img *ngIf="loggedIn" src="../../assets/img/{{themeService.theme}}/scd-logo.png" alt="Company Logo"
				[routerLink]="['/home']" width="125px">
		</div>
		<div class="company-logo">
			<span class="sponsor-name">Provided by <br> {{sponsorFirstName + ' ' + sponsorLastName}}</span>
			<!-- <img *ngIf="logoUrl" src="{{logoUrl}}" alt="{{company}}" width="80px"> -->
		</div>
	</section>

	<ng-container *ngIf="loggedIn">
		<div class="dropdown" (click)="openScdMenu($event)" id="scdMenuDropdown"
			[ngClass]="{'dropdown-collapsed': statusScdMenu, 'dropdown-bluecoat': themeService.theme == 'bluecoat'}">
			<div class="dropdown-scd-menu">
				<div class="icon" [ngClass]="statusScdMenu ? 'scd-menu-icon-collapsed' : ''">
					<div class="user-name">
						<i class="fa fas fa-user user-img"></i>
						<img *ngIf="avatarUrl" class="user-avatar" src="{{avatarUrl}}" alt="User's Avatar"
							width="100px">
						<span class="name" [ngClass]="statusScdMenu ? 'name-collapsed' : ''">{{myUser.firstName + " " +
							myUser.lastName}}</span>
						<i class="fa fas fa-chevron-down chevron-down"
							[ngClass]="statusScdMenu ? 'chevron-collapsed' : ''"></i>
					</div>
					<div class="dropdown-links" [ngClass]="statusScdMenu ? 'dropdown-links-collapsed' : ''">
						<a *ngIf="showSideNav=='bottom'" class="dropdown-item"
							(click)="goToFromScdMenu('plan-review')">Plan
							Review</a>
						<a *ngIf="showSideNav=='top' && myUser.userType != 'professional'" class="dropdown-item"
							(click)="goToFromScdMenu('request-access')">Request Access to a Plan</a>
						<a *ngIf="showSideNav=='bottom'" class="dropdown-item" (click)="goToFromScdMenu('delegate')">Add
							a Delegate</a>
						<!-- <a *ngIf="showSideNav=='bottom'" class="dropdown-item"
						   [routerLink]="['/friend-invitation']">Invite a Friend</a> -->
						<a *ngIf="showSideNav=='bottom'" class="dropdown-item"
							(click)="goToFromScdMenu('deleted-items')">Deleted Items</a>
						<a *ngIf="showSideNav=='top'
							|| showSideNav=='bottom'
							|| myUser.userType == 'professional'
							|| myUser.userType == 'professionalManager'
							|| myUser.userType == 'admin'" class="dropdown-item" (click)="goToFromScdMenu('account-settings')">Account
							Settings</a>
						<a *ngIf="showSideNav=='bottom' && myUser.userType != 'professional'" class="dropdown-item"
							(click)="goToFromScdMenu('security-page')">Security</a>
						<a *ngIf="myUser.subscriptionId || myUser.userType == 'professionalManager' || companyDetails && companyDetails.funded == false"
							class="dropdown-item" (click)="openPortal()">Subscription &amp; Payment Settings</a>
						<a class="dropdown-item" (click)="logout()">Log Out</a>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<img *ngIf="themeService.theme == 'bluecoat' && loggedIn && chosenNav == 'dashboard'" class="bluecoat-right-logo" src="../../assets/img/bluecoat/icon-logo.png" alt="">
</nav>

<!-- Side Nav -->
<aside *ngIf="loggedIn" class="side-nav-container" id="sideNavContainer" [ngClass]="statusNav ? 'nav-toggled' : ''"
	[class.sponsor-side-nav]="logoSponsor == true">

	<!-- Sponsor -->
	<section class="sponsor-presentation" *ngIf="companyDetails &&
				   companyDetails.firstName &&
				   companyDetails.lastName &&
				   themeService.theme != 'boosst' &&
				   themeService.theme != 'weightmans' &&
				   themeService.theme != 'bluecoat' &&
				   logoSponsor == true
				   && (hideSponsor == false || hideSponsor == undefined) 
				   && mobileScreen == false && 
				   myUser.userType && 
				   myUser.userType != 'professional' && 
				   myUser.userType!='professionalManager'" [ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<div class="company-logo" *ngIf="companyDetails && 
										 companyDetails.firstName && 
										 companyDetails.lastName && 
										 themeService.theme != 'boosst'">
			<span>Provided by <br> {{sponsorFirstName + ' ' + sponsorLastName}}</span> <br>
			<img *ngIf="logoSponsor==true" src="{{logoUrl}}" alt="{{company}}" width="70px">
		</div>
	</section>

	<!-- Delegate & Create Plan -->
	<!-- <section *ngIf="showSideNav=='top' && myUser.userType != 'professional'"
		[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<section class="side-nav-links create-plan-today" *ngIf="activeTheme.name == 'defaultTheme'">
			<div class="start-plan">
				<div class="start-plan-today">See how Zenplans can help you
					to organise your life's most important
					information.</div>
				<input type="button" class="form-control btn btn-primary primary-default-btn create-my-plan"
					value="Create My Plan" (click)="goCreatePlan()">
			</div>
		</section>
	</section> -->

	<!-- Delegate -->
	<section
		*ngIf="showSideNav=='top' && myUser && myUser.userType != 'professional' && myUser.userType != 'professionalManager'"
		[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<section class="side-nav-links create-plan-today" *ngIf="activeTheme.name == 'defaultTheme'">
			<input type="button" class="form-control btn btn-primary primary-default-btn create-my-plan" value="Home"
				[routerLink]="'/delegate-home-page'">
		</section>
	</section>

	<!-- Delegate With No Shared Plans-->
	<section
		*ngIf="showSideNav=='top-empty' && myUser && myUser.userType != 'professional' && myUser.userType != 'professionalManager'"
		[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<section class="side-nav-links create-plan-today" *ngIf="activeTheme.name == 'defaultTheme'">
			<input type="button" class="form-control btn btn-primary primary-default-btn create-my-plan" value="Home"
				[routerLink]="'/delegate-home-page'">
		</section>
	</section>

	<!-- Professional -->
	<div *ngIf="myUser && myUser.userType == 'professional'"
		[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<section class="side-nav-links professional-area">
			<div class="user-img">
				<input type="button" class="form-control btn btn-primary primary-default-btn" value="Home"
					(click)="goToProfessionalHomePage()">
			</div>
		</section>
		<section class="empty-state-professional shared-plans-nav" *ngIf="mySharedPlans && mySharedPlans.length == 0">
			<div class="side-nav-section-title">
				Shared Plans
			</div>

			<div class="all-shared-plan-users">
				<div class="empty-state-professional-text">Clients that have shared their plan with you will appear
					here.</div>
			</div>
		</section>
	</div>

	<!-- Manager Professional -->
	<div *ngIf="myUser && myUser.userType == 'professionalManager'"
		[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<section class="side-nav-links professional-area">
			<div class="user-img">
				<input type="button" class="form-control btn btn-primary primary-default-btn" value="Home"
					(click)="goToProfessionalHomePage()">
			</div>
		</section>
	</div>

	<!-- Side Navigation -->
	<section *ngIf="myUser && myUser.userType && myUser.userType != 'admin' && myUser.userType!='professional' && dataIsLoaded==true"
		[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<section class="side-nav-links">
			<ul>
				<li (click)="seeMyPlan($event,'dashboard')" [ngClass]="{activeNav:chosenNav=='dashboard'}">
					<div class="nav-name">
						<a>
							<svg width="20" height="20" class="svg-icon"
								[ngClass]="{changeColorFa:chosenNav=='dashboard'}">
								<path clip-rule="evenodd"
									d="M0 3.28792C0 2.63693 0.258603 2.01261 0.71892 1.55229C1.17924 1.09198 1.80356 0.833374 2.45455 0.833374H15.5455C16.1964 0.833374 16.8208 1.09198 17.2811 1.55229C17.7414 2.01261 18 2.63693 18 3.28792V16.3788C18 17.0298 17.7414 17.6541 17.2811 18.1145C16.8208 18.5748 16.1964 18.8334 15.5455 18.8334H2.45455C1.80356 18.8334 1.17924 18.5748 0.71892 18.1145C0.258603 17.6541 0 17.0298 0 16.3788V3.28792ZM2.45455 2.46974C2.23755 2.46974 2.02944 2.55594 1.876 2.70938C1.72256 2.86282 1.63636 3.07092 1.63636 3.28792V16.3788C1.63636 16.5958 1.72256 16.8039 1.876 16.9574C2.02944 17.1108 2.23755 17.197 2.45455 17.197H15.5455C15.7625 17.197 15.9706 17.1108 16.124 16.9574C16.2774 16.8039 16.3636 16.5958 16.3636 16.3788V3.28792C16.3636 3.07092 16.2774 2.86282 16.124 2.70938C15.9706 2.55594 15.7625 2.46974 15.5455 2.46974H2.45455Z" />
								<path clip-rule="evenodd"
									d="M0 3.28792C0 2.63693 0.258603 2.01261 0.71892 1.55229C1.17924 1.09198 1.80356 0.833374 2.45455 0.833374H15.5455C16.1964 0.833374 16.8208 1.09198 17.2811 1.55229C17.7414 2.01261 18 2.63693 18 3.28792V9.01519H0V3.28792ZM2.45455 2.46974C2.23755 2.46974 2.02944 2.55594 1.876 2.70938C1.72256 2.86282 1.63636 3.07092 1.63636 3.28792V7.37883H16.3636V3.28792C16.3636 3.07092 16.2774 2.86282 16.124 2.70938C15.9706 2.55594 15.7625 2.46974 15.5455 2.46974H2.45455Z" />
								<path clip-rule="evenodd"
									d="M0 16.3788C0 17.0298 0.258603 17.6541 0.71892 18.1145C1.17924 18.5748 1.80356 18.8334 2.45455 18.8334H8.18182V7.37883H0V16.3788ZM2.45455 17.197C2.23755 17.197 2.02944 17.1108 1.876 16.9574C1.72256 16.8039 1.63636 16.5958 1.63636 16.3788L1.63636 9.01519H6.54546V17.197L2.45455 17.197Z" />
							</svg>
						</a>
						<span>Dashboard</span>
					</div>
				</li>
				<li (click)="seeMyPlan($event,'assets')" [ngClass]="{activeNav:chosenNav=='assets'}">
					<div class="nav-name">
						<a>
							<svg width="20" height="20" class="svg-icon"
								[ngClass]="{changeColorFa:chosenNav=='assets'}">
								<path
									d="M16.4273 0.5907C16.2756 0.231491 15.9244 0 15.5412 0H3.46378C3.07264 0 2.72141 0.231491 2.57773 0.5907L0.0712446 6.65735C-0.184193 7.28796 0.278788 7.98244 0.957295 7.98244H2.1387V14.3684H1.51607C1.07703 14.3684 0.717822 14.7276 0.717822 15.1666C0.717822 15.6057 1.07703 15.9649 1.51607 15.9649H3.09659H6.28956H12.3562H15.5492H17.4809C17.92 15.9649 18.2792 15.6057 18.2792 15.1666C18.2792 14.7276 17.92 14.3684 17.4809 14.3684H16.5071V7.98244H18.0397C18.7182 7.98244 19.1892 7.28796 18.9258 6.65735L16.4273 0.5907ZM13.9447 7.98244H14.9186V14.3684H12.5238V9.73857C12.5238 9.21173 12.0928 8.78068 11.566 8.78068H7.09579C6.56895 8.78068 6.1379 9.21173 6.1379 9.73857V14.3684H3.74317V7.98244H5.06027H13.9447ZM4.85272 6.38595H1.91519L3.88685 1.59649H15.1102L17.0818 6.38595H14.1443H4.85272ZM10.9114 14.3684H7.74236V10.3692H10.9114V14.3684Z" />
							</svg>
						</a>
						<span>Assets</span>
					</div>
					<span class="label">{{assetsCount}}</span>
				</li>
				<li (click)="seeMyPlan($event,'debts')" [ngClass]="{activeNav:chosenNav=='debts'}">
					<div class="nav-name">
						<a>
							<svg class="svg-icon" width="19" height="15" [ngClass]="{changeColorFa:chosenNav=='debts'}">
								<path
									d="M16.4091 0H2.59091C1.90376 0 1.24475 0.289731 0.75886 0.805456C0.27297 1.32118 0 2.02065 0 2.75V11.9167C0 12.646 0.27297 13.3455 0.75886 13.8612C1.24475 14.3769 1.90376 14.6667 2.59091 14.6667H16.4091C17.0962 14.6667 17.7553 14.3769 18.2411 13.8612C18.727 13.3455 19 12.646 19 11.9167V2.75C19 2.02065 18.727 1.32118 18.2411 0.805456C17.7553 0.289731 17.0962 0 16.4091 0ZM2.59091 1.83333H16.4091C16.6381 1.83333 16.8578 1.92991 17.0198 2.10182C17.1817 2.27373 17.2727 2.50688 17.2727 2.75V3.66667H1.72727V2.75C1.72727 2.50688 1.81826 2.27373 1.98023 2.10182C2.14219 1.92991 2.36186 1.83333 2.59091 1.83333ZM16.4091 12.8333H2.59091C2.36186 12.8333 2.14219 12.7368 1.98023 12.5648C1.81826 12.3929 1.72727 12.1598 1.72727 11.9167V5.5H17.2727V11.9167C17.2727 12.1598 17.1817 12.3929 17.0198 12.5648C16.8578 12.7368 16.6381 12.8333 16.4091 12.8333Z" />
								<path
									d="M3.45455 9.16666H6.90909C7.13814 9.16666 7.35781 9.07008 7.51977 8.89817C7.68174 8.72627 7.77273 8.49311 7.77273 8.24999C7.77273 8.00688 7.68174 7.77372 7.51977 7.60181C7.35781 7.4299 7.13814 7.33333 6.90909 7.33333H3.45455C3.22549 7.33333 3.00583 7.4299 2.84386 7.60181C2.6819 7.77372 2.59091 8.00688 2.59091 8.24999C2.59091 8.49311 2.6819 8.72627 2.84386 8.89817C3.00583 9.07008 3.22549 9.16666 3.45455 9.16666Z" />
								<path
									d="M9.5 10.0833H3.45455C3.22549 10.0833 3.00583 10.1799 2.84386 10.3518C2.6819 10.5237 2.59091 10.7569 2.59091 11C2.59091 11.2431 2.6819 11.4763 2.84386 11.6482C3.00583 11.8201 3.22549 11.9167 3.45455 11.9167H9.5C9.72905 11.9167 9.94872 11.8201 10.1107 11.6482C10.2726 11.4763 10.3636 11.2431 10.3636 11C10.3636 10.7569 10.2726 10.5237 10.1107 10.3518C9.94872 10.1799 9.72905 10.0833 9.5 10.0833Z" />
							</svg>
						</a>
						<span>Debts</span>
					</div>
					<span class="label">{{debtsCount}}</span>
				</li>
				<li (click)="seeMyPlan($event,'daily life')" [ngClass]="{activeNav:chosenNav=='daily life'}">
					<div class="nav-name">
						<a>
							<svg class="svg-icon" width="20" height="20"
								[ngClass]="{changeColorFa:chosenNav=='daily life'}">
								<path clip-rule="evenodd"
									d="M16.4091 3.45455H14.6818V2.59091C14.6818 1.15727 13.5245 0 12.0909 0H6.90909C5.47545 0 4.31818 1.15727 4.31818 2.59091V3.45455H2.59091C1.15727 3.45455 0 4.61182 0 6.04545V14.6818C0 16.1155 1.15727 17.2727 2.59091 17.2727H16.4091C17.8427 17.2727 19 16.1155 19 14.6818V6.04545C19 4.61182 17.8427 3.45455 16.4091 3.45455ZM6.04545 2.59091C6.04545 2.11591 6.43409 1.72727 6.90909 1.72727H12.0909C12.5659 1.72727 12.9545 2.11591 12.9545 2.59091V3.45455H6.04545V2.59091ZM17.2727 14.6818C17.2727 15.1568 16.8841 15.5455 16.4091 15.5455H2.59091C2.11591 15.5455 1.72727 15.1568 1.72727 14.6818V6.04545C1.72727 5.57045 2.11591 5.18182 2.59091 5.18182H16.4091C16.8841 5.18182 17.2727 5.57045 17.2727 6.04545V14.6818Z" />
							</svg>
						</a>
						<span>Daily Life</span>
					</div>
					<span class="label">{{myDailyLifeCount}}</span>
				</li>
				<li (click)="seeMyPlan($event,'digital life')" [ngClass]="{activeNav:chosenNav=='digital life'}">
					<div class="nav-name">
						<a>
							<svg class="svg-icon" width="20" height="20"
								[ngClass]="{changeColorFa:chosenNav=='digital life'}">
								<path class="st0" d="M10,0.1C4.5,0.1,0,4.5,0,10s4.5,10,10,10c5.5,0,10-4.5,10-10S15.5,0.1,10,0.1z M17.1,5.8h-2.9
	c-0.3-1.3-0.7-2.5-1.2-3.5C14.7,3,16.1,4.3,17.1,5.8z M18.2,10c0,0.9-0.1,1.7-0.4,2.4h-3.4c0.1-0.8,0.1-1.6,0.1-2.4
	c0-0.8,0-1.6-0.1-2.4h3.4C18.1,8.4,18.2,9.2,18.2,10z M10,18.3c-0.8,0-1.8-1.5-2.4-4h4.8C11.8,16.8,10.8,18.3,10,18.3z M7.3,12.5
	c-0.1-0.8-0.1-1.6-0.1-2.4c0-0.9,0.1-1.7,0.1-2.4h5.4c0.1,0.8,0.1,1.6,0.1,2.4c0,0.9-0.1,1.7-0.1,2.4H7.3z M1.8,10
	c0-0.9,0.1-1.7,0.4-2.4h3.4C5.5,8.4,5.4,9.2,5.4,10c0,0.8,0,1.6,0.1,2.4H2.1C1.9,11.7,1.8,10.9,1.8,10z M10,1.8c0.8,0,1.8,1.5,2.4,4
	H7.6C8.2,3.3,9.2,1.8,10,1.8z M7,2.4c-0.5,1-0.9,2.2-1.2,3.5H2.9C3.9,4.3,5.3,3,7,2.4z M2.9,14.2h2.9c0.3,1.3,0.7,2.5,1.2,3.5
	C5.3,17,3.9,15.8,2.9,14.2z M13,17.7c0.5-1,0.9-2.2,1.2-3.5h2.9C16.1,15.8,14.7,17,13,17.7z" />
							</svg>
						</a>
						<span>Digital Life</span>
					</div>
					<span class="label">{{myDigitalLifeCount}}</span>
				</li>
				<li (click)="seeMyPlan($event,'wishes')" [ngClass]="{activeNav:chosenNav=='wishes'}">
					<div class="nav-name">
						<a>
							<svg class="svg-icon" width="20" height="20"
								[ngClass]="{changeColorFa:chosenNav=='wishes'}">
								<path clip-rule="evenodd"
									d="M11.8318 1.11409C11.3482 0.414545 10.5536 0 9.70727 0H2.59091C1.15727 0 0 1.15727 0 2.59091V16.4091C0 17.8427 1.15727 19 2.59091 19H12.9545C14.3882 19 15.5455 17.8427 15.5455 16.4091V7.25455C15.5455 6.72773 15.3814 6.20955 15.0791 5.77773L11.8318 1.11409ZM13.8182 16.4091C13.8182 16.8841 13.4295 17.2727 12.9545 17.2727H2.59091C2.11591 17.2727 1.72727 16.8841 1.72727 16.4091V2.59091C1.72727 2.11591 2.11591 1.72727 2.59091 1.72727H9.70727C9.99227 1.72727 10.2514 1.86545 10.4155 2.09864L13.6627 6.76227C13.7664 6.90909 13.8182 7.08182 13.8182 7.25455V16.4091Z" />
							</svg>
						</a>
						<span>Wishes</span>
					</div>
					<span class="label">{{wishesCount}}</span>
				</li>
				<li (click)="seeMyPlan($event,'summaries')" [ngClass]="{activeNav:chosenNav=='summaries'}">
					<div class="nav-name nav-financial" *ngIf="isNFZ==false">
						<a>
							<svg class="svg-icon" width="20" height="20"
								[ngClass]="{changeColorFa:chosenNav=='summaries'}">
								<path clip-rule="evenodd"
									d="M18.1364 13.8182H17.2382V7.08182C17.2382 6.51182 16.7718 6.04545 16.2018 6.04545H13.9564C13.3864 6.04545 12.92 6.51182 12.92 7.08182V13.8182H12.0564V1.03636C12.0564 0.466364 11.59 0 11.02 0H8.77455C8.20455 0 7.73818 0.466364 7.73818 1.03636V13.8182H6.87455V4.49091C6.87455 3.92091 6.40818 3.45455 5.83818 3.45455H3.59273C3.02273 3.45455 2.55636 3.92091 2.55636 4.49091V13.8182H0.863636C0.388636 13.8182 0 14.2068 0 14.6818C0 15.1568 0.388636 15.5455 0.863636 15.5455H3.59273H5.83818H8.77455H11.02H13.9564H16.2018H18.1364C18.6114 15.5455 19 15.1568 19 14.6818C19 14.2068 18.6114 13.8182 18.1364 13.8182ZM4.28364 13.8182V5.18182H5.14727V13.8182H4.28364ZM9.46546 13.8182V1.72727H10.3291V13.8182H9.46546ZM14.6473 13.8182V7.77273H15.5109V13.8182H14.6473Z" />
							</svg>
						</a>
						<span>Financial Summaries</span>
					</div>
				</li>
				<li (click)="seeMyPlan($event,'delegates')" [ngClass]="{activeNav:chosenNav=='delegates'}">
					<div class="nav-name">
						<a>
							<svg class="svg-icon" width="20" height="20"
								[ngClass]="{changeColorFa:chosenNav=='delegates'}">
								<path clip-rule="evenodd"
									d="M5.97753 4.26966C5.97753 3.76299 6.12778 3.26769 6.40927 2.8464C6.69077 2.42512 7.09086 2.09677 7.55897 1.90287C8.02708 1.70897 8.54217 1.65824 9.03911 1.75709C9.53605 1.85594 9.99252 2.09993 10.3508 2.4582C10.7091 2.81647 10.9531 3.27294 11.0519 3.76988C11.1508 4.26682 11.1 4.78191 10.9061 5.25002C10.7122 5.71813 10.3839 6.11823 9.96259 6.39972C9.5413 6.68121 9.046 6.83146 8.53933 6.83146C7.8599 6.83146 7.20829 6.56156 6.72786 6.08113C6.24743 5.6007 5.97753 4.94909 5.97753 4.26966ZM5.58472 7.35236C3.94527 7.95695 2.53076 9.04994 1.53209 10.4838C0.533417 11.9177 -0.00133491 13.6234 2.50251e-06 15.3708V16.2247C2.50251e-06 16.4512 0.0899701 16.6684 0.250114 16.8285C0.410257 16.9887 0.627458 17.0787 0.853935 17.0787C1.08041 17.0787 1.29761 16.9887 1.45776 16.8285C1.6179 16.6684 1.70787 16.4512 1.70787 16.2247V15.3708C1.70787 13.559 2.42761 11.8214 3.70876 10.5402C4.9899 9.25907 6.72751 8.53933 8.53933 8.53933C9.53102 8.53922 10.4917 8.19392 11.2566 7.56268C12.0215 6.93145 12.5427 6.05366 12.7309 5.08C12.9191 4.10633 12.7626 3.09751 12.2881 2.22671C11.8135 1.35591 11.0507 0.677435 10.1305 0.307755C9.2103 -0.0619256 8.1901 -0.0997563 7.24503 0.200756C6.29997 0.501269 5.48899 1.12138 4.95129 1.95465C4.4136 2.78792 4.18272 3.78237 4.29831 4.7673C4.41389 5.75223 4.86872 6.66622 5.58472 7.35236ZM11.8611 10.4607C11.1856 10.4607 10.5252 10.661 9.96345 11.0363C9.40173 11.4117 8.96393 11.9451 8.7054 12.5693C8.44687 13.1934 8.37923 13.8802 8.51103 14.5428C8.64283 15.2054 8.96814 15.814 9.44584 16.2917C9.92354 16.7694 10.5322 17.0947 11.1948 17.2265C11.8573 17.3583 12.5441 17.2907 13.1683 17.0321C13.7924 16.7736 14.3259 16.3358 14.7012 15.7741C15.0765 15.2124 15.2769 14.552 15.2769 13.8764C15.2769 12.9705 14.917 12.1017 14.2764 11.4611C13.6358 10.8205 12.767 10.4607 11.8611 10.4607ZM6.73753 13.8764C6.73753 12.8631 7.03802 11.8725 7.60101 11.0299C8.164 10.1873 8.9642 9.53061 9.90041 9.14282C10.8366 8.75503 11.8668 8.65356 12.8607 8.85126C13.8546 9.04895 14.7675 9.53693 15.4841 10.2535C16.2006 10.97 16.6886 11.883 16.8863 12.8768C17.084 13.8707 16.9825 14.9009 16.5947 15.8371C16.2069 16.7733 15.5502 17.5735 14.7076 18.1365C13.8651 18.6995 12.8745 19 11.8611 19C10.5023 19 9.19906 18.4602 8.2382 17.4993C7.27734 16.5385 6.73753 15.2353 6.73753 13.8764ZM9.6836 12.9029C9.49106 12.9029 9.30285 12.96 9.14276 13.067C8.98267 13.174 8.8579 13.326 8.78422 13.5039C8.71054 13.6818 8.69126 13.8775 8.72882 14.0663C8.76638 14.2552 8.8591 14.4286 8.99524 14.5648C9.13139 14.7009 9.30484 14.7936 9.49368 14.8312C9.68252 14.8687 9.87825 14.8495 10.0561 14.7758C10.234 14.7021 10.3861 14.5773 10.493 14.4172C10.6 14.2572 10.6571 14.0689 10.6571 13.8764C10.6571 13.6182 10.5545 13.3706 10.372 13.188C10.1894 13.0055 9.94178 12.9029 9.6836 12.9029ZM10.8876 13.8764C10.8876 13.6839 10.9447 13.4957 11.0517 13.3356C11.1587 13.1755 11.3107 13.0507 11.4886 12.977C11.6665 12.9033 11.8622 12.8841 12.051 12.9216C12.2399 12.9592 12.4133 13.0519 12.5495 13.188C12.6856 13.3242 12.7783 13.4977 12.8159 13.6865C12.8535 13.8753 12.8342 14.0711 12.7605 14.2489C12.6868 14.4268 12.5621 14.5789 12.402 14.6858C12.2419 14.7928 12.0537 14.8499 11.8611 14.8499C11.6029 14.8499 11.3553 14.7473 11.1728 14.5648C10.9902 14.3822 10.8876 14.1346 10.8876 13.8764ZM14.0387 12.9029C13.8465 12.9046 13.6591 12.9631 13.5002 13.0711C13.3412 13.1791 13.2178 13.3317 13.1454 13.5097C13.073 13.6878 13.0549 13.8832 13.0935 14.0715C13.132 14.2598 13.2254 14.4324 13.3618 14.5677C13.4983 14.703 13.6718 14.7949 13.8604 14.8318C14.049 14.8686 14.2443 14.8489 14.4217 14.7749C14.5991 14.701 14.7506 14.5762 14.8572 14.4163C14.9638 14.2564 15.0207 14.0686 15.0207 13.8764C15.0207 13.7478 14.9952 13.6206 14.9458 13.5019C14.8963 13.3832 14.8238 13.2755 14.7325 13.185C14.6412 13.0945 14.5329 13.023 14.4138 12.9746C14.2947 12.9261 14.1672 12.9018 14.0387 12.9029Z" />
							</svg>
						</a>
						<span>Delegates</span>
					</div>
					<span class="label">{{delegatesCount}}</span>
				</li>
			</ul>
		</section>
	</section>

	<!-- Shared Plans -->
	<section *ngIf="(showSideNav!='neither' && dataIsLoaded && mySharedPlans.length > 0) ||
					(myUser.userType == 'professional' && mySharedPlans && mySharedPlans.length > 0)"
		[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<section class="shared-plans-nav">
			<div class="side-nav-section-title">
				<span [ngClass]="{'shared-plan-color': hasPlan == null}">Shared Plans</span>
			</div>
			<section class="all-shared-plan-users">
				<input *ngIf="mySharedPlans && mySharedPlans.length > 1" class="shared-plans-search" type="text"
					[(ngModel)]="email" placeholder="Search a name">
				<section class="shared-plan-users"
					*ngFor="let sharedPlan of mySharedPlans | customerEmailFilter:email; let i = index;">
					<ul class="shared-plan-user">
						<li (click)="activateClass(sharedPlan,openSharedPlan===i ? undefined : i);"
							[ngClass]="{activeNav:i===openSharedPlan}">
							<div class="nav-name">
								<a>
									<i class="fa fa-2x fa-user-circle icon-user"></i>
								</a>
								<div class="shared-plan-user-name">
									<span class="first-name">{{sharedPlan.clientName}}</span>
								</div>
							</div>
							<span class="arrow">
								<i [ngClass]="{'activeArrow': i===openSharedPlan}"
									class="fa fa-2x fa-chevron-down icon-collapse">
								</i>
							</span>
						</li>
					</ul>
					<ul class="shared-plan-info" [ngClass]="{'sharedPlanInfoToggled': i===openSharedPlan}"
						id="sharedPlanInfo">
						<li (click)="seeSharedPlan($event,'dashboard',sharedPlan)"
							[ngClass]="{activeNav:chosenNavSharedPlan=='dashboard'}" style="display:none;">
							<div class="nav-name">
								<a>
									<svg width="18" height="19" class="svg-icon"
										[ngClass]="{changeColorFa:chosenNavSharedPlan=='dashboard'}">
										<path clip-rule="evenodd"
											d="M0 3.28792C0 2.63693 0.258603 2.01261 0.71892 1.55229C1.17924 1.09198 1.80356 0.833374 2.45455 0.833374H15.5455C16.1964 0.833374 16.8208 1.09198 17.2811 1.55229C17.7414 2.01261 18 2.63693 18 3.28792V16.3788C18 17.0298 17.7414 17.6541 17.2811 18.1145C16.8208 18.5748 16.1964 18.8334 15.5455 18.8334H2.45455C1.80356 18.8334 1.17924 18.5748 0.71892 18.1145C0.258603 17.6541 0 17.0298 0 16.3788V3.28792ZM2.45455 2.46974C2.23755 2.46974 2.02944 2.55594 1.876 2.70938C1.72256 2.86282 1.63636 3.07092 1.63636 3.28792V16.3788C1.63636 16.5958 1.72256 16.8039 1.876 16.9574C2.02944 17.1108 2.23755 17.197 2.45455 17.197H15.5455C15.7625 17.197 15.9706 17.1108 16.124 16.9574C16.2774 16.8039 16.3636 16.5958 16.3636 16.3788V3.28792C16.3636 3.07092 16.2774 2.86282 16.124 2.70938C15.9706 2.55594 15.7625 2.46974 15.5455 2.46974H2.45455Z" />
										<path clip-rule="evenodd"
											d="M0 3.28792C0 2.63693 0.258603 2.01261 0.71892 1.55229C1.17924 1.09198 1.80356 0.833374 2.45455 0.833374H15.5455C16.1964 0.833374 16.8208 1.09198 17.2811 1.55229C17.7414 2.01261 18 2.63693 18 3.28792V9.01519H0V3.28792ZM2.45455 2.46974C2.23755 2.46974 2.02944 2.55594 1.876 2.70938C1.72256 2.86282 1.63636 3.07092 1.63636 3.28792V7.37883H16.3636V3.28792C16.3636 3.07092 16.2774 2.86282 16.124 2.70938C15.9706 2.55594 15.7625 2.46974 15.5455 2.46974H2.45455Z" />
										<path clip-rule="evenodd"
											d="M0 16.3788C0 17.0298 0.258603 17.6541 0.71892 18.1145C1.17924 18.5748 1.80356 18.8334 2.45455 18.8334H8.18182V7.37883H0V16.3788ZM2.45455 17.197C2.23755 17.197 2.02944 17.1108 1.876 16.9574C1.72256 16.8039 1.63636 16.5958 1.63636 16.3788L1.63636 9.01519H6.54546V17.197L2.45455 17.197Z" />
									</svg>
								</a>
								<span>Dashboard</span>
							</div>
						</li>
						<li *ngIf="sharedPlan.assetsPermission=='now' || sharedPlan.assetsPermission=='contributor'"
							(click)="seeSharedPlan($event,'assets',sharedPlan)"
							[ngClass]="{activeNav:chosenNavSharedPlan=='assets'}">
							<div class="nav-name">
								<a>
									<svg width="19" height="16" class="svg-icon"
										[ngClass]="{changeColorFa:chosenNavSharedPlan=='assets'}">
										<path
											d="M16.4273 0.5907C16.2756 0.231491 15.9244 0 15.5412 0H3.46378C3.07264 0 2.72141 0.231491 2.57773 0.5907L0.0712446 6.65735C-0.184193 7.28796 0.278788 7.98244 0.957295 7.98244H2.1387V14.3684H1.51607C1.07703 14.3684 0.717822 14.7276 0.717822 15.1666C0.717822 15.6057 1.07703 15.9649 1.51607 15.9649H3.09659H6.28956H12.3562H15.5492H17.4809C17.92 15.9649 18.2792 15.6057 18.2792 15.1666C18.2792 14.7276 17.92 14.3684 17.4809 14.3684H16.5071V7.98244H18.0397C18.7182 7.98244 19.1892 7.28796 18.9258 6.65735L16.4273 0.5907ZM13.9447 7.98244H14.9186V14.3684H12.5238V9.73857C12.5238 9.21173 12.0928 8.78068 11.566 8.78068H7.09579C6.56895 8.78068 6.1379 9.21173 6.1379 9.73857V14.3684H3.74317V7.98244H5.06027H13.9447ZM4.85272 6.38595H1.91519L3.88685 1.59649H15.1102L17.0818 6.38595H14.1443H4.85272ZM10.9114 14.3684H7.74236V10.3692H10.9114V14.3684Z" />
									</svg>
								</a>
								<span>Assets</span>
							</div>
						</li>
						<li *ngIf="sharedPlan.debtsPermission=='now' || sharedPlan.debtsPermission=='contributor'"
							(click)="seeSharedPlan($event,'debts',sharedPlan)"
							[ngClass]="{activeNav:chosenNavSharedPlan=='debts'}">
							<div class="nav-name">
								<a>
									<svg class="svg-icon" width="19" height="15"
										[ngClass]="{changeColorFa:chosenNavSharedPlan=='debts'}">
										<path
											d="M16.4091 0H2.59091C1.90376 0 1.24475 0.289731 0.75886 0.805456C0.27297 1.32118 0 2.02065 0 2.75V11.9167C0 12.646 0.27297 13.3455 0.75886 13.8612C1.24475 14.3769 1.90376 14.6667 2.59091 14.6667H16.4091C17.0962 14.6667 17.7553 14.3769 18.2411 13.8612C18.727 13.3455 19 12.646 19 11.9167V2.75C19 2.02065 18.727 1.32118 18.2411 0.805456C17.7553 0.289731 17.0962 0 16.4091 0ZM2.59091 1.83333H16.4091C16.6381 1.83333 16.8578 1.92991 17.0198 2.10182C17.1817 2.27373 17.2727 2.50688 17.2727 2.75V3.66667H1.72727V2.75C1.72727 2.50688 1.81826 2.27373 1.98023 2.10182C2.14219 1.92991 2.36186 1.83333 2.59091 1.83333ZM16.4091 12.8333H2.59091C2.36186 12.8333 2.14219 12.7368 1.98023 12.5648C1.81826 12.3929 1.72727 12.1598 1.72727 11.9167V5.5H17.2727V11.9167C17.2727 12.1598 17.1817 12.3929 17.0198 12.5648C16.8578 12.7368 16.6381 12.8333 16.4091 12.8333Z" />
										<path
											d="M3.45455 9.16666H6.90909C7.13814 9.16666 7.35781 9.07008 7.51977 8.89817C7.68174 8.72627 7.77273 8.49311 7.77273 8.24999C7.77273 8.00688 7.68174 7.77372 7.51977 7.60181C7.35781 7.4299 7.13814 7.33333 6.90909 7.33333H3.45455C3.22549 7.33333 3.00583 7.4299 2.84386 7.60181C2.6819 7.77372 2.59091 8.00688 2.59091 8.24999C2.59091 8.49311 2.6819 8.72627 2.84386 8.89817C3.00583 9.07008 3.22549 9.16666 3.45455 9.16666Z" />
										<path
											d="M9.5 10.0833H3.45455C3.22549 10.0833 3.00583 10.1799 2.84386 10.3518C2.6819 10.5237 2.59091 10.7569 2.59091 11C2.59091 11.2431 2.6819 11.4763 2.84386 11.6482C3.00583 11.8201 3.22549 11.9167 3.45455 11.9167H9.5C9.72905 11.9167 9.94872 11.8201 10.1107 11.6482C10.2726 11.4763 10.3636 11.2431 10.3636 11C10.3636 10.7569 10.2726 10.5237 10.1107 10.3518C9.94872 10.1799 9.72905 10.0833 9.5 10.0833Z" />
									</svg>
								</a>
								<span>Debts</span>
							</div>
						</li>
						<li *ngIf="sharedPlan.dailyLifePermission=='now' || sharedPlan.dailyLifePermission=='contributor'"
							(click)="seeSharedPlan($event,'daily life',sharedPlan)"
							[ngClass]="{activeNav:chosenNavSharedPlan=='daily life'}">
							<div class="nav-name">
								<a>
									<svg class="svg-icon" width="19" height="18"
										[ngClass]="{changeColorFa:chosenNavSharedPlan=='daily life'}">
										<path clip-rule="evenodd"
											d="M16.4091 3.45455H14.6818V2.59091C14.6818 1.15727 13.5245 0 12.0909 0H6.90909C5.47545 0 4.31818 1.15727 4.31818 2.59091V3.45455H2.59091C1.15727 3.45455 0 4.61182 0 6.04545V14.6818C0 16.1155 1.15727 17.2727 2.59091 17.2727H16.4091C17.8427 17.2727 19 16.1155 19 14.6818V6.04545C19 4.61182 17.8427 3.45455 16.4091 3.45455ZM6.04545 2.59091C6.04545 2.11591 6.43409 1.72727 6.90909 1.72727H12.0909C12.5659 1.72727 12.9545 2.11591 12.9545 2.59091V3.45455H6.04545V2.59091ZM17.2727 14.6818C17.2727 15.1568 16.8841 15.5455 16.4091 15.5455H2.59091C2.11591 15.5455 1.72727 15.1568 1.72727 14.6818V6.04545C1.72727 5.57045 2.11591 5.18182 2.59091 5.18182H16.4091C16.8841 5.18182 17.2727 5.57045 17.2727 6.04545V14.6818Z" />
									</svg>
								</a>
								<span>Daily Life</span>
							</div>
						</li>
						<li *ngIf="sharedPlan.digitalLifePermission=='now' || sharedPlan.digitalLifePermission=='contributor'"
							(click)="seeSharedPlan($event,'digital life',sharedPlan)"
							[ngClass]="{activeNav:chosenNavSharedPlan=='digital life'}">
							<div class="nav-name">
								<a>
									<svg class="svg-icon" width="19" height="18"
										[ngClass]="{changeColorFa:chosenNavSharedPlan=='digital life'}">
										<path class="st0" d="M10,0.1C4.5,0.1,0,4.5,0,10s4.5,10,10,10c5.5,0,10-4.5,10-10S15.5,0.1,10,0.1z M17.1,5.8h-2.9
	c-0.3-1.3-0.7-2.5-1.2-3.5C14.7,3,16.1,4.3,17.1,5.8z M18.2,10c0,0.9-0.1,1.7-0.4,2.4h-3.4c0.1-0.8,0.1-1.6,0.1-2.4
	c0-0.8,0-1.6-0.1-2.4h3.4C18.1,8.4,18.2,9.2,18.2,10z M10,18.3c-0.8,0-1.8-1.5-2.4-4h4.8C11.8,16.8,10.8,18.3,10,18.3z M7.3,12.5
	c-0.1-0.8-0.1-1.6-0.1-2.4c0-0.9,0.1-1.7,0.1-2.4h5.4c0.1,0.8,0.1,1.6,0.1,2.4c0,0.9-0.1,1.7-0.1,2.4H7.3z M1.8,10
	c0-0.9,0.1-1.7,0.4-2.4h3.4C5.5,8.4,5.4,9.2,5.4,10c0,0.8,0,1.6,0.1,2.4H2.1C1.9,11.7,1.8,10.9,1.8,10z M10,1.8c0.8,0,1.8,1.5,2.4,4
	H7.6C8.2,3.3,9.2,1.8,10,1.8z M7,2.4c-0.5,1-0.9,2.2-1.2,3.5H2.9C3.9,4.3,5.3,3,7,2.4z M2.9,14.2h2.9c0.3,1.3,0.7,2.5,1.2,3.5
	C5.3,17,3.9,15.8,2.9,14.2z M13,17.7c0.5-1,0.9-2.2,1.2-3.5h2.9C16.1,15.8,14.7,17,13,17.7z" />
									</svg>
								</a>
								<span>Digital Life</span>
							</div>
						</li>
						<li *ngIf="sharedPlan.wishesPermission=='now' || sharedPlan.wishesPermission=='contributor'"
							(click)="seeSharedPlan($event,'wishes',sharedPlan)"
							[ngClass]="{activeNav:chosenNavSharedPlan=='wishes'}">
							<div class="nav-name">
								<a>
									<svg class="svg-icon" width="16" height="19"
										[ngClass]="{changeColorFa:chosenNavSharedPlan=='wishes'}">
										<path clip-rule="evenodd"
											d="M11.8318 1.11409C11.3482 0.414545 10.5536 0 9.70727 0H2.59091C1.15727 0 0 1.15727 0 2.59091V16.4091C0 17.8427 1.15727 19 2.59091 19H12.9545C14.3882 19 15.5455 17.8427 15.5455 16.4091V7.25455C15.5455 6.72773 15.3814 6.20955 15.0791 5.77773L11.8318 1.11409ZM13.8182 16.4091C13.8182 16.8841 13.4295 17.2727 12.9545 17.2727H2.59091C2.11591 17.2727 1.72727 16.8841 1.72727 16.4091V2.59091C1.72727 2.11591 2.11591 1.72727 2.59091 1.72727H9.70727C9.99227 1.72727 10.2514 1.86545 10.4155 2.09864L13.6627 6.76227C13.7664 6.90909 13.8182 7.08182 13.8182 7.25455V16.4091Z" />
									</svg>
								</a>
								<span>Wishes</span>
							</div>
						</li>
						<li *ngIf="isNFZForSharedPlan==false && dataIsLoaded && (sharedPlan.assetsPermission=='now' || sharedPlan.assetsPermission=='contributor')
                                    && (sharedPlan.debtsPermission=='now' || sharedPlan.debtsPermission=='contributor')
                                    && (sharedPlan.dailyLifePermission=='now' || sharedPlan.dailyLifePermission=='contributor')
									&& (sharedPlan.digitalLifePermission=='now' || sharedPlan.digitalLifePermission=='contributor')"
							(click)="seeSharedPlan($event,'summaries',sharedPlan)"
							[ngClass]="{activeNav:chosenNavSharedPlan=='summaries'}">
							<div class="nav-name">
								<a>
									<svg class="svg-icon" width="19" height="16"
										[ngClass]="{changeColorFa:chosenNavSharedPlan=='summaries'}">
										<path clip-rule="evenodd"
											d="M18.1364 13.8182H17.2382V7.08182C17.2382 6.51182 16.7718 6.04545 16.2018 6.04545H13.9564C13.3864 6.04545 12.92 6.51182 12.92 7.08182V13.8182H12.0564V1.03636C12.0564 0.466364 11.59 0 11.02 0H8.77455C8.20455 0 7.73818 0.466364 7.73818 1.03636V13.8182H6.87455V4.49091C6.87455 3.92091 6.40818 3.45455 5.83818 3.45455H3.59273C3.02273 3.45455 2.55636 3.92091 2.55636 4.49091V13.8182H0.863636C0.388636 13.8182 0 14.2068 0 14.6818C0 15.1568 0.388636 15.5455 0.863636 15.5455H3.59273H5.83818H8.77455H11.02H13.9564H16.2018H18.1364C18.6114 15.5455 19 15.1568 19 14.6818C19 14.2068 18.6114 13.8182 18.1364 13.8182ZM4.28364 13.8182V5.18182H5.14727V13.8182H4.28364ZM9.46546 13.8182V1.72727H10.3291V13.8182H9.46546ZM14.6473 13.8182V7.77273H15.5109V13.8182H14.6473Z" />
									</svg>
								</a>
								<span class="shared-plans-fs">Financial Summaries</span>
							</div>
						</li>
					</ul>
				</section>
			</section>
		</section>
	</section>

	<!-- Delegate With No Shared Plans -->
	<section *ngIf="(showSideNav=='top-empty')"
		[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
		<section class="shared-plans-nav">
			<div class="side-nav-section-title">
				<span [ngClass]="{'shared-plan-color': hasPlan == null}">Shared Plans</span>
			</div>
		</section>
		<section class="no-shared-plans-message">
			<div>People who have shared their zenplan with you will appear here</div>
		</section>
	</section>

		<!-- Admin Dashboard -->
		<section *ngIf="myUser.userType=='admin'"
			[ngClass]="{hideSideNav:sideNavBarVisibilityService.hideSideNav==true}">
			<section class="side-nav-links admin-dashboard-links">
				<ul>
					<li (click)="seeAdminDashboard($event,'accounts')" [ngClass]="{activeNav:chosenNav=='accounts'}">
						<div class="nav-name">
							<span>Accounts</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'professionals')"
						[ngClass]="{activeNav:chosenNav=='professionals'}">
						<div class="nav-name">
							<span>Professionals</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'partners')" [ngClass]="{activeNav:chosenNav=='partners'}">
						<div class="nav-name">
							<span>Partners</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'analytics')" [ngClass]="{activeNav:chosenNav=='analytics'}">
						<div class="nav-name">
							<span>Analytics</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'lists')" [ngClass]="{activeNav:chosenNav=='lists'}">
						<div class="nav-name nav-financial">
							<span>Lists</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'monitoring')"
						[ngClass]="{activeNav:chosenNav=='monitoring'}">
						<div class="nav-name">
							<span>Monitoring</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'copy editor')"
						[ngClass]="{activeNav:chosenNav=='copy editor'}">
						<div class="nav-name">
							<span>Copy Editor</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'mail rules')"
						[ngClass]="{activeNav:chosenNav=='mail rules'}">
						<div class="nav-name">
							<span>Mail Rules</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'resources')" [ngClass]="{activeNav:chosenNav=='mail store'}">
						<div class="nav-name">
							<span>Resources</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'suggestion rules')"
						[ngClass]="{activeNav:chosenNav=='suggestion rules'}">
						<div class="nav-name">
							<span>Suggested Next Steps</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'roles')" [ngClass]="{activeNav:chosenNav=='roles'}">
						<div class="nav-name">
							<span>Roles</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'mail log')" [ngClass]="{activeNav:chosenNav=='mail log'}">
						<div class="nav-name">
							<span>Mail Log</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'events log')"
						[ngClass]="{activeNav:chosenNav=='events log'}">
						<div class="nav-name">
							<span>Events Log</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'ref codes')" [ngClass]="{activeNav:chosenNav=='ref codes'}">
						<div class="nav-name">
							<span>Ref Codes</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'auditlog')" [ngClass]="{activeNav:chosenNav=='auditlog'}">
						<div class="nav-name">
							<span>Audit Log</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'unlock request')"
						[ngClass]="{activeNav:chosenNav=='unlock request'}">
						<div class="nav-name">
							<span>Unlock Request</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'mail queue')"
						[ngClass]="{activeNav:chosenNav=='mail queue'}">
						<div class="nav-name">
							<span>Mail Queue</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'client access page')"
						[ngClass]="{activeNav:chosenNav=='client access page'}">
						<div class="nav-name">
							<span>Client Access Page</span>
						</div>
					</li>
					<li (click)="seeAdminDashboard($event,'delegate referral')"
						[ngClass]="{activeNav:chosenNav=='delegate referral'}">
						<div class="nav-name">
							<span>Delegate Referral</span>
						</div>
					</li>
				</ul>
			</section>
		</section>
</aside>